module.exports = __webpack_public_path__ + "media/icons/unchecked-3ca4ce34.png";